import React, { FunctionComponent, useCallback, useContext } from 'react';
import { Handling, HandlingType } from '../../types/graph';
import { TerminalContext } from '../TerminalRoot';
import HandlingForm from './HandlingForm';

const BASE_URL = process.env.REACT_APP_PUBLIC_URL;

const HandlingAddPage: FunctionComponent = () => {

    const { terminal } = useContext(TerminalContext);
    //const [id, setId] = useState(idFromState ?? Number(idFromParams));

    const handleSaved = useCallback((handling: Handling) => {
        if (terminal === null) {
            return;
        }

        const { loadingUnitIdentifier, checkedIn, type } = handling;
        const { slug } = terminal;

        const unitNumberSlug = loadingUnitIdentifier?.toLowerCase();

        if (checkedIn === true) {
            window.location.replace(`${BASE_URL}/${slug}/unita-in-sosta/${unitNumberSlug}`)
            return;
        }

        switch (type) {
            case HandlingType.Boarding:
            case HandlingType.TranshipmentBoarding:
                window.location.replace(`${BASE_URL}/${slug}/export-previsti/${unitNumberSlug}`)
                return;

            case HandlingType.Unboarding:
            case HandlingType.TranshipmentUnboarding:
                window.location.replace(`${BASE_URL}/${slug}/import-previsti/${unitNumberSlug}`)
                return;

            case HandlingType.Transit:
                window.location.replace(`${BASE_URL}/${slug}/transiti-previsti/${unitNumberSlug}`)
                return;
        }
    }, [terminal]);

    return <HandlingForm onSaved={handleSaved as any} />;
};

export default HandlingAddPage;